import * as React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CakeIcon from "@mui/icons-material/Cake";
import CelebrationIcon from "@mui/icons-material/Celebration";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import { set } from "lodash";
import { Stack } from "@mui/material";

dayjs.extend(utc);
dayjs.extend(timezone);
const todayEST = dayjs().tz("America/New_York").startOf("day");

const initialValue = dayjs(todayEST);

function Birthday(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

  const dayStr = dayjs(day).format("YYYY-MM-DD");
  const isHighlighted =
    !outsideCurrentMonth && highlightedDays.includes(dayStr);

  return (
    <Box sx={{ position: "relative" }}>
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
      />
      {isHighlighted && (
        <CelebrationIcon
          fontSize="small"
          sx={{
            position: "absolute",
            bottom: 2, // 👈 put below number
            left: "40%",
            top: "-0%",
            transform: "translateX(-50%)",
            pointerEvents: "none", // 👈 prevent blocking taps
            color: "secondary.main",
          }}
        />
      )}
    </Box>
  );
}
function ActionBar({ onClear, closeCalendar, onSelectToday }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-between",
        justifyContent: "center",
        gap: 1,
        padding: 1,
        height: "160px",
      }}
    >
      {/* <Button size="small" onClick={onClear}>
        All
      </Button> */}
      <Button
        variant="text"
        size="small"
        onClick={closeCalendar}
        sx={{
          color: "gray",
          alignSelf: "center",
          fontSize: "30px",
          marginTop: "40px",
          marginBottom: "50px",
        }}
      >
        X
      </Button>
      <Button size="small" onClick={onSelectToday}>
        Today
      </Button>
    </Box>
  );
}

export default function DatePickerWithSafeIcons({ onDateChange, partyDates }) {
  const [value, setValue] = React.useState(initialValue);
  const [open, setOpen] = React.useState(false);

  const highlightedDays = partyDates;
  const ty = 1;

  const handleChange = (newValue) => {
    setValue(newValue);
    // ✅ Expose the picked value to parent or other code
    if (onDateChange) {
      onDateChange(dayjs(newValue).format("YYYY-MM-DD")); // or pass the Dayjs object
    }
    setOpen(false); // ✅ close the picker
  };

  // const handleClear = () => {
  //   setValue(null); // Clear selected date
  //   setOpen(false); // ✅ close the picker
  // };
  const handleSelectToday = () => {
    // Get New York (Eastern) today
    const nyToday = dayjs().tz("America/New_York").startOf("day");
    setValue(nyToday);
    // if (onDateChange) {
    //   onDateChange(dayjs(nyToday).format("YYYY-MM-DD")); // or pass the Dayjs object
    // }
    handleChange(nyToday);
    // setOpen(false); // ✅ close the picker
  };

  const didRunRef = React.useRef(false);

  useEffect(() => {
    if (didRunRef.current) return;
    didRunRef.current = true;

    handleSelectToday();
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        sx={{
          width: 160,
          "& .MuiOutlinedInput-input": {
            height: "8px", // Adjust as needed
          },
        }}
        label="Date"
        value={value}
        open={open}
        onOpen={() => setOpen(true)}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} fullWidth />}
        slots={{
          day: Birthday,
          actionBar: (props) => (
            <ActionBar
              // onClear={handleClear}
              onSelectToday={handleSelectToday}
              closeCalendar={() => setOpen(false)}
            />
          ),
        }}
        slotProps={{
          day: { highlightedDays },
        }}
      />
    </LocalizationProvider>
  );
}
